import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { NopagefoundComponent } from './shared/nopagefound/nopagefound.component';
import { RotateComponent } from './shared/rotate/rotate.component';

const appRoutes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'rotate', component: RotateComponent },
    // { path: 'register', component: RegisterComponent },
    { path: '**', component: NopagefoundComponent }
];

export const APP_ROUTES = RouterModule.forRoot( appRoutes, { useHash: true } );
